module.exports = __webpack_public_path__ + "static/media/ic_EU_PL.177d3fb4.svg";